"use client";

import { useState } from "react";
import { trackFAQOpen } from "@/lib/analytics";
import { faqs } from "@/data/faq";

export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full py-24 px-6 max-w-3xl mx-auto" id="faq">
      <h2 className="text-4xl font-black font-display text-center mb-16">Frequently Asked Questions</h2>
      <div className="space-y-4">
        {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return (
            <div key={i} className="bg-white border-2 border-border-thick rounded-xl shadow-brutal-sm">
              <button
                onClick={() => {
                  if (!isOpen) trackFAQOpen(faq.q);
                  setOpenIndex(isOpen ? null : i);
                }}
                className="w-full flex items-center justify-between p-6 text-left font-bold text-lg font-display cursor-pointer"
                aria-expanded={isOpen}
              >
                <span>{faq.q}</span>
                <svg
                  width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                  className={`transition-transform shrink-0 ml-4 ${isOpen ? "rotate-180" : ""}`}
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button>
              <div
                className="grid transition-all duration-300"
                style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
              >
                <div className="overflow-hidden">
                  <p className="text-border-thick/60 font-medium px-6 pb-6">{faq.a}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
